module.exports = __webpack_public_path__ + "static/img/logo-color.9de6f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-color.png
// module id = Dqjr
// module chunks = 17